let product = [
    {
        "id": 1,
        "title": "WMNS Blossom Anorak 8149 PINK",
        "title_kr":"우먼스 블라썸 아노락 8149 핑크",
        "imgUrl": "img/c1.jpg",
        "price": 168000
    },
    {
        "id": 2,
        "title": "WMNS Blossom Anorak 8149 YELLOW",
        "title_kr":"우먼스 블라썸 아노락 8149 옐로우",
        "imgUrl": "img/c2.jpg",
        "price": 168000
    },
    {
        "id": 3,
        "title": "Blossom Anorak 8145 WHITE",
        "title_kr":"블라썸 아노락 8145 화이트",
        "imgUrl": "img/c3.jpg",
        "price": 168000
    },
    {
        "id": 4,
        "title": "Blossom Anorak 8145 GREY",
        "title_kr":"블라썸 아노락 8145 그레이",
        "imgUrl": "img/c4.jpg",
        "price": 168000
    }
]

export default product;